import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { ButtonComponent, ButtonGroupComponent } from '@libs/common/components';
import { ProductModel } from '@libs/shop/models';
import { ProductPriceFormatterComponent } from '../../../catalog/product-prices/product-price-formatter';

@Component({
  selector: 'ui-configurable-bundle-order-card-footer',
  imports: [
    ButtonGroupComponent,
    ProductPriceFormatterComponent,
    ButtonComponent,
  ],
  templateUrl: './configurable-bundle-order-card-footer.component.html',
  styleUrl: 'configurable-bundle-order-card-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurableBundleOrderCardFooterComponent {
  public product: InputSignal<ProductModel> = input.required();
  public readonly: InputSignal<boolean> = input.required();
  public isRemoveLoading: InputSignal<boolean> = input(false);

  public edit: OutputEmitterRef<void> = output();
  public remove: OutputEmitterRef<void> = output();
}
